/* Onmifit para Dawn: header, menú (escritorio y celular), contador del carro y buscador predictivo. Sin dependencias. */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- Carro: contador y carro lateral de Dawn ---------- */
  function updateCartCount() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-om-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = !cart.item_count;
        });
      })
      .catch(function () {});
  }
  if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, updateCartCount);
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) updateCartCount(); });

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-om-cart-link]');
    if (!link) return;
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      e.preventDefault();
      drawer.open(link);
    }
  });

  /* ---------- Header: menú móvil y altura ---------- */
  var header = document.querySelector('.om-header');
  function setHeaderH() {
    if (!header) return;
    var h = header.offsetHeight + 'px';
    document.documentElement.style.setProperty('--om-header-h', h);
    document.documentElement.style.setProperty('--header-height', h);
  }
  setHeaderH();
  window.addEventListener('resize', setHeaderH);

  var drawer = document.querySelector('.om-drawer');
  document.querySelectorAll('[data-om-drawer-open]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!drawer) return;
      drawer.classList.add('is-open');
      document.documentElement.classList.add('om-lock');
      b.setAttribute('aria-expanded', 'true');
      var c = drawer.querySelector('.om-drawer-close');
      if (c) setTimeout(function () { c.focus({ preventScroll: true }); }, 60);
    });
  });
  function closeDrawer() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('om-lock');
    document.querySelectorAll('[data-om-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-om-drawer-close]')) closeDrawer();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  /* ---------- Portada: reflejo de vidrio que sigue al mouse ---------- */
  if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('pointermove', function (e) {
      var card = e.target.closest && e.target.closest('.om-hmain, .om-promo');
      if (!card) return;
      var r = card.getBoundingClientRect();
      card.style.setProperty('--om-mx', (e.clientX - r.left) + 'px');
      card.style.setProperty('--om-my', (e.clientY - r.top) + 'px');
    }, { passive: true });
  }

  /* ---------- Menú por bloques: abrir y cerrar submenús ---------- */
  function setOpen(item, open) {
    item.classList.toggle('is-open', open);
    var t = item.querySelector(':scope > .sf-nav__top .sf-nav__toggle');
    if (t) t.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function closeDesktopMenus(except) {
    document.querySelectorAll('.om-menu .sf-nav__item.is-open').forEach(function (it) {
      if (it !== except) setOpen(it, false);
    });
  }
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.sf-nav__toggle, .sf-nav__link--toggle');
    if (trigger) {
      e.preventDefault();
      var item = trigger.closest('.sf-nav__item');
      var open = !item.classList.contains('is-open');
      if (item.closest('.om-menu')) closeDesktopMenus(item);
      setOpen(item, open);
      return;
    }
    if (!e.target.closest('.om-menu')) closeDesktopMenus();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDesktopMenus();
  });
  /* En el editor, al seleccionar una categoría se abre su submenú */
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target && e.target.closest && e.target.closest('.om-menu .sf-nav__item');
    if (item) { closeDesktopMenus(item); setOpen(item, true); }
  });
  document.addEventListener('shopify:block:deselect', function () { closeDesktopMenus(); });

  /* ---------- Buscador predictivo con categorías y filtros ---------- */
  var search = document.querySelector('[data-om-search]');
  if (!search) return;
  var form = search.querySelector('form');
  var input = search.querySelector('input[type="search"]');
  var select = search.querySelector('select[data-om-cat]');
  var panel = search.querySelector('.om-panel');
  var results = panel.querySelector('[data-sf-results]') || panel;
  var filters = panel.querySelector('[data-sf-filters]');
  var catFilter = panel.querySelector('select[data-sf-cat]');
  var vendorFilter = panel.querySelector('select[data-sf-vendor]');
  var priceFilter = panel.querySelector('select[data-sf-price]');
  var stockFilter = panel.querySelector('input[data-sf-stock]');
  var emptyTpl = search.querySelector('template[data-om-empty]');
  var url = search.getAttribute('data-url');
  var searchUrl = search.getAttribute('data-search-url') || root + 'search';
  var types = search.getAttribute('data-types') || 'product,collection,query';
  var limit = parseInt(search.getAttribute('data-limit'), 10) || 8;
  var unavailable = search.getAttribute('data-unavailable') || 'last';
  var cache = {};
  var timer, controller;

  function open() { panel.hidden = false; input.setAttribute('aria-expanded', 'true'); }
  function close() { panel.hidden = true; input.setAttribute('aria-expanded', 'false'); }

  function category() {
    if (select) return select.value;
    return catFilter ? catFilter.value : '';
  }
  function categoryUrl() {
    var opt = select && select.options[select.selectedIndex];
    return opt ? opt.getAttribute('data-url') : '';
  }
  function priceRange() {
    if (!priceFilter || !priceFilter.value) return null;
    var p = priceFilter.value.split('-');
    return { lo: parseFloat(p[0]) || 0, hi: p[1] ? parseFloat(p[1]) : null };
  }
  function activeFilters() {
    return {
      vendor: vendorFilter ? vendorFilter.value : '',
      range: priceRange(),
      stock: !!(stockFilter && stockFilter.checked)
    };
  }

  function resultsUrl(q) {
    var f = activeFilters();
    var params = ['q=' + encodeURIComponent(q), 'type=product', 'options%5Bprefix%5D=last'];
    if (f.stock) params.push('filter.v.availability=1');
    if (f.vendor) params.push('filter.p.vendor=' + encodeURIComponent(f.vendor));
    if (f.range) {
      params.push('filter.v.price.gte=' + f.range.lo);
      if (f.range.hi !== null) params.push('filter.v.price.lte=' + f.range.hi);
    }
    return searchUrl + '?' + params.join('&');
  }

  function applyFilters() {
    var q = input.value.trim();
    var cat = category();
    var f = q ? activeFilters() : { vendor: '', range: null, stock: false };
    var items = results.querySelectorAll('[data-om-collections]');
    var matched = 0;
    var shown = 0;
    items.forEach(function (it) {
      var price = parseFloat(it.getAttribute('data-price')) || 0;
      var ok = (!cat || (' ' + it.getAttribute('data-om-collections') + ' ').indexOf(' ' + cat + ' ') > -1) &&
        (!f.vendor || it.getAttribute('data-vendor') === f.vendor) &&
        (!f.stock || it.getAttribute('data-available') === 'true') &&
        (!f.range || (price >= f.range.lo && (f.range.hi === null || price <= f.range.hi)));
      if (ok) matched++;
      var visible = ok && shown < limit;
      if (visible) shown++;
      it.hidden = !visible;
    });
    var empty = results.querySelector('[data-om-cat-empty]');
    if (empty) empty.hidden = !(items.length && matched === 0);
    var count = results.querySelector('[data-sf-count]');
    if (count && q) count.textContent = matched + ' resultado' + (matched === 1 ? '' : 's');
    if (q) {
      results.querySelectorAll('[data-sf-all], [data-sf-term-link]').forEach(function (a) { a.href = resultsUrl(q); });
    }
    /* Si la columna de la izquierda quedó vacía, los productos usan todo el ancho */
    var aside = results.querySelector('.om-ps-aside');
    if (aside) {
      var visible = Array.prototype.some.call(aside.children, function (c) { return getComputedStyle(c).display !== 'none'; });
      aside.hidden = !visible;
      aside.parentNode.classList.toggle('sf-ps-full', !visible);
    }
  }

  function render(html) {
    results.innerHTML = html;
    if (filters) filters.hidden = !input.value.trim();
    open();
    applyFilters();
  }

  function showEmpty() {
    if (emptyTpl) render(emptyTpl.innerHTML);
  }

  function query(q) {
    if (cache[q]) { render(cache[q]); return; }
    if (controller) controller.abort();
    controller = 'AbortController' in window ? new AbortController() : null;
    var params = 'q=' + encodeURIComponent(q) +
      '&resources[type]=' + encodeURIComponent(types) +
      '&resources[limit]=10&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=' + encodeURIComponent(unavailable) +
      '&section_id=onmifit-predictive';
    fetch(url + '?' + params, controller ? { signal: controller.signal } : {})
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var res = doc.querySelector('.om-ps');
        var html = res ? res.outerHTML : '';
        cache[q] = html;
        if (input.value.trim() === q) render(html);
      })
      .catch(function () {});
  }

  input.addEventListener('input', function () {
    var q = input.value.trim();
    clearTimeout(timer);
    if (!q) { showEmpty(); return; }
    timer = setTimeout(function () { query(q); }, 180);
  });
  input.addEventListener('focus', function () {
    var q = input.value.trim();
    if (q) query(q); else showEmpty();
  });

  /* Selector de categoría del buscador y el del panel (celular) van sincronizados */
  function onCategory(source) {
    if (select && source !== select) select.value = source.value;
    if (catFilter && source !== catFilter) catFilter.value = source.value;
    if (!panel.hidden) applyFilters();
  }
  if (select) select.addEventListener('change', function () { onCategory(select); input.focus(); });
  if (catFilter) catFilter.addEventListener('change', function () { onCategory(catFilter); });
  [vendorFilter, priceFilter, stockFilter].forEach(function (el) {
    if (el) el.addEventListener('change', applyFilters);
  });

  /* Al buscar: con categoría y sin texto abre la colección; con filtros lleva los filtros a la página de resultados */
  form.addEventListener('submit', function (e) {
    var q = input.value.trim();
    if (!q) {
      var cu = categoryUrl();
      e.preventDefault();
      if (cu) window.location.href = cu;
      else input.focus();
      return;
    }
    var f = activeFilters();
    if (f.vendor || f.range || f.stock) {
      e.preventDefault();
      window.location.href = resultsUrl(q);
    }
  });

  panel.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-om-chip]');
    if (chip) {
      e.preventDefault();
      input.value = chip.getAttribute('data-om-chip');
      input.focus();
      query(input.value.trim());
    }
  });
  document.addEventListener('click', function (e) {
    if (!search.contains(e.target)) close();
  });
  search.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { close(); input.focus(); return; }
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    if (panel.hidden || e.target.tagName === 'SELECT') return;
    var links = Array.prototype.filter.call(results.querySelectorAll('a'), function (a) { return a.offsetParent !== null; });
    if (!links.length) return;
    e.preventDefault();
    var i = links.indexOf(document.activeElement);
    i = e.key === 'ArrowDown' ? Math.min(links.length - 1, i + 1) : i - 1;
    if (i < 0) input.focus(); else links[i].focus();
  });
})();
